import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import IMask from 'imask';
import Helper from './helper';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.partnerCarousel();
        this.headerCarousel();
        this.storyCarousel();

        this.navbarDropdowns();
        this.navbarCollapse();
        this.navbarObserver();
        this.fileUploads();
        this.honeyForms();
        this.asyncForms();
        this.formBuilder();
        this.searchBar();
        this.cookies();
        this.iMask();
        this.popup();
        this.autoModals();
        this.scrollIntoView();
        this.responsiveEmbeds();
    }

    partnerCarousel() {
        document.querySelectorAll('.content__partners-slider').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                centeredSlides: true,
                autoplay: true,
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 25
                    },
                    500: {
                        slidesPerView: 3,
                        spaceBetween: 25
                    },
                    576: {
                        slidesPerView: 4,
                        spaceBetween: 25
                    },
                    768: {
                        slidesPerView: 5,
                        spaceBetween: 25
                    },
                    992: {
                        spaceBetween: 25,
                        slidesPerView: 6,
                    },
                    1200: {
                        spaceBetween: 50,
                        slidesPerView: 7,
                    },
                    1400: {
                        spaceBetween: 100,
                        slidesPerView: 'auto'
                    }
                },
                slidesPerGroup: 1
            });
        });
    }

    headerCarousel() {
        document.querySelectorAll('.header-home__slider').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                allowTouchMove: false,
                slidesPerGroup: 1,
                slidesPerView: 1,
                spaceBetween: 0,
                effect: 'fade',
                speed: 1500,
                loop: true,
                autoplay: {
                    delay: 5000
                },
                fadeEffect: {
                    crossFade: true
                }
            });
        });
    }

    storyCarousel() {
        document.querySelectorAll('.stories__slider').forEach(element => {
            let paginationOptions = {}, pagination = element.closest('.stories__slider-wrapper').querySelector('.swiper-pagination');

            if (pagination) {
                // Create pagination
                paginationOptions = {
                    clickable 	: true,
                    type        : 'bullets',
                    el			: '#' + pagination.getAttribute('id')
                };
            }

            new Swiper('#' + element.getAttribute('id'), {
                navigation: {
                    prevEl: element.querySelector('.stories__slider-nav-arrow--prev'),
                    nextEl: element.querySelector('.stories__slider-nav-arrow--next')
                },
                pagination: paginationOptions,
                slidesPerGroup: 1,
                spaceBetween: 25,
                autoplay: {
                    delay: 5000
                },
                loop: true,
                breakpoints: {
                    0: {
                        centeredSlides: false,
                        slidesPerView: 1
                    },
                    576: {
                        centeredSlides: false,
                        slidesPerView: 1
                    },
                    768: {
                        centeredSlides: true,
                        slidesPerView: 'auto'
                    },
                    992: {
                        centeredSlides: true,
                        slidesPerView: 'auto'
                    },
                    1200: {
                        centeredSlides: true,
                        slidesPerView: 'auto'
                    },
                    1400: {
                        centeredSlides: true,
                        slidesPerView: 'auto'
                    }
                }
            });
        });
    }

    navbarDropdowns() {
        const navbarList = document.getElementById('main-navbar-list');

        if (navbarList === null) {
            return false;
        }

        navbarList.querySelectorAll('.dropdown').forEach(dropdown => {
            const dropdownToggle = dropdown.querySelector('.dropdown-toggle');

            dropdownToggle.addEventListener('show.bs.dropdown', event => {
                document.body.classList.add('submenu-open');
            });

            dropdownToggle.addEventListener('hide.bs.dropdown', event => {
                setTimeout(() => {
                    // Delay removal to allow another dropdown to be opened immediately
                    const anyOpenDropdown = navbarList.querySelector('.dropdown-menu.show');

                    if (anyOpenDropdown === null) {
                        document.body.classList.remove('submenu-open');
                    }
                }, 100); // Allow enough time for the new dropdown to potentially open
            });
        });

        const submenuDropdownToggles = navbarList.querySelectorAll('.main-navbar__submenu-dropdown-toggle');

        submenuDropdownToggles.forEach(submenuDropdownToggle => {
            const dropdownMenu = submenuDropdownToggle.closest('.main-navbar__submenu-dropdown').querySelector('.main-navbar__submenu-dropdown-menu');

            submenuDropdownToggle.addEventListener('click', e => {
                e.preventDefault();

                submenuDropdownToggle.classList.toggle('show');

                if (dropdownMenu) {
                    dropdownMenu.classList.toggle('show');
                }
            });
        });
    }

    navbarCollapse() {
        const navbarCollapse = document.getElementById('main-navbar-content');

        if (navbarCollapse === null) {
            return false;
        }

        navbarCollapse.addEventListener('show.bs.collapse', event => {
            document.body.classList.add('navbar-collapse-open');
        });

        navbarCollapse.addEventListener('hide.bs.collapse', event => {
            document.body.classList.remove('navbar-collapse-open');
        });
    }

    navbarObserver() {
        const desktopWidth = 1200;

        const observeWindowSize = () => {
            // Check minimum window width
            if (window.innerWidth < desktopWidth) {
                // Check if the submenu open state is active
                if (document.body.classList.contains('submenu-open')) {
                    // Remove submenu open state
                    document.body.classList.remove('submenu-open');
                }
            }
            else {
                // Check if the collapse open state is active
                if (document.body.classList.contains('navbar-collapse-open')) {
                    // Remove navbar collapse open state
                    document.body.classList.remove('navbar-collapse-open');
                }
            }
        }

        window.addEventListener('resize', Helper.debounce(() => observeWindowSize()));
    }

    fileUploads() {
        Helper.bindEventListener(document, 'change', '.form-upload input[type="file"]', function () {
            let fileName = this.closest('.form-upload').querySelector('.filename');

            // Toggle visibility
            fileName.style.display = 'inline';

            // Update contents
            fileName.innerText = this.files[0].name;
        });
    }

    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        document.querySelectorAll('.form-honey').forEach(form => {
            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    buttonSubmit.innerHTML = buttonSubmit.getAttribute('data-text');

                    // Enable the submit button
                    buttonSubmit.disabled = false;
                }

                let coffeeCup = form.querySelector('input[name="coffee_cup"]');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';
                }
            }, 5000);
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let gRecaptchaWidgets = [];

        document.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
            let widgetId = grecaptcha.render(recaptcha.id, {
                'sitekey' : config.recaptcha_site_key
            });

            gRecaptchaWidgets.push(widgetId);
        });

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (typeof grecaptcha === 'undefined') {
                return;
            }

            // Refresh all recaptcha widget instances
            gRecaptchaWidgets.forEach(widgetId => {
                grecaptcha.reset(widgetId);
            });
        }

        setInterval(function() {
            refreshRecaptcha();
        }, 2 * 60 * 1000);

        document.querySelectorAll('.form-async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh reCAPTCHA
                        refreshRecaptcha();

                        formMessages.innerHTML = '<div class="alert alert--' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh reCAPTCHA
                    refreshRecaptcha();

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    /**
     * Process asynchronous forms
     */
    formBuilder() {
        let getConditionalInputs = function (form, conditional) {
            return Array.from(form.querySelectorAll(`[name="${conditional}"]`));
        }

        let getConditionalInputValue = function (form, conditional) {
            let conditionalInputs = getConditionalInputs(form, conditional);

            if (conditionalInputs.length === 0) {
                return null;
            }

            let conditionalInput = conditionalInputs.find(input => input.type !== 'hidden') || conditionalInputs[0];

            if (conditionalInput.type === 'radio') {
                return form.querySelector(`[name="${conditional}"]:checked`)?.value || '';
            }

            if (conditionalInput.type === 'checkbox') {
                return conditionalInput.checked ? conditionalInput.value : '0';
            }

            return conditionalInput.value;
        }

        let checkConditionalValue = function (form, input) {
            let conditional = input.getAttribute('data-conditional');

            if (conditional === null) {
                return true;
            }

            let conditionalValue = input.getAttribute('data-conditional-value');
            let currentValue = getConditionalInputValue(form, conditional);

            if (currentValue === null) {
                return true;
            }

            return currentValue === conditionalValue;
        }

        let bindConditionalFields = function (form = document) {
            form.querySelectorAll('[data-conditional]').forEach(item => {
                let conditional = item.getAttribute('data-conditional');
                let conditionalInputs = getConditionalInputs(form, conditional).filter(input => input.type !== 'hidden');

                if (conditionalInputs.length === 0) {
                    return;
                }

                let updateConditionalField = function () {
                    let input = item.querySelector('.form-input');
                    let isConditionalValue = checkConditionalValue(form, item);

                    // Toggle display
                    item.style.display = isConditionalValue
                        ? 'block'
                        : 'none';

                    if (input && input.getAttribute('data-required') !== null) {
                        isConditionalValue ? input.setAttribute('required', 'required') : input.removeAttribute('required');
                    }
                }

                conditionalInputs.forEach(inputConditional => {
                    inputConditional.addEventListener('change', Helper.debounce(updateConditionalField));
                });

                updateConditionalField();
            });
        }

        Helper.bindEventListener(document, 'submit', '.form-builder', (e) => {
            e.preventDefault();

            let form = e.target;

            let formContainer = form.closest('.form-builder-container');
            let formMessages = form.querySelector('.form-messages');
            let spinner = form.querySelector('.spinner-border');

            // Clear the form messages
            formMessages.replaceChildren();

            if (spinner) {
                // Show the spinner icon
                spinner.style.display = 'block';
            }

            Helper.request(form.action, new FormData(form), 'json', form.method).then(response => {
                if (spinner) {
                    // Hide the spinner icon
                    spinner.style.display = 'none';
                }

                if (response.html) {
                    // Update html contents
                    formContainer.innerHTML = response.html;

                    // Find the newly rendered form inside the container
                    let newForm = formContainer.querySelector('.form-builder');

                    if (newForm) {
                        // Re-apply honey form initialisation so the submit button
                        // gets re-enabled after the form is replaced in the DOM
                        let buttonSubmit = newForm.querySelector('button[type="submit"]');
                        let coffeeCup    = newForm.querySelector('input[name="coffee_cup"]');

                        setTimeout(() => {
                            if (buttonSubmit) {
                                buttonSubmit.innerHTML = buttonSubmit.getAttribute('data-text');
                                buttonSubmit.disabled  = false;
                            }

                            if (coffeeCup) {
                                coffeeCup.value = 'filled';
                            }
                        }, 5000);

                        // Re-render reCAPTCHA widgets inside the new form
                        if (typeof grecaptcha !== 'undefined') {
                            newForm.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
                                // Pass the element reference (not its ID string) so reCAPTCHA
                                // treats the fresh DOM node as a new widget instead of
                                // rejecting it as an already-registered ID.
                                grecaptcha.render(recaptcha, {
                                    'sitekey': config.recaptcha_site_key
                                });
                            });
                        }

                        // Re-bind conditional fields on the new form
                        bindConditionalFields(newForm);
                    }
                }

                if (response.message) {
                    // Update form message contents
                    let newFormMessages = formContainer.querySelector('.form-messages');

                    if (newFormMessages) {
                        newFormMessages.innerHTML = '<div class="alert alert-success"><span>' + response.message + '</span></div>';
                    }
                }
            })
            .catch(error => {
                // Show notification
                alert('Er is iets misgegaan.');

                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });

        bindConditionalFields();
    }

    searchBar() {
        const inputSearch = document.getElementById('search-input');
        const toggleSearch = document.getElementById('search-toggle');
        const placeholderSearch = document.getElementById('search-placeholder');

        if (inputSearch === null || toggleSearch === null || placeholderSearch === null) {
            return false;
        }

        const dropdownSearch = bootstrap.Dropdown.getOrCreateInstance(toggleSearch);

        // Find all elements with the data-action close search attribute
        document.querySelectorAll('[data-action="close-search"]').forEach(buttonToggle => {
            // Bind the click event listener to the button
            buttonToggle.addEventListener('click', function () {
                dropdownSearch.hide();
            });
        });

        const messages = [
            'HR diensten van HN-AB',
            'toekomstbestendig werkgeverschap',
            'duurzame inzetbaarheid',
            'contracten',
            'inclusieve werkomgevingen'
        ];

        let current = 0, currentSpan = null;

        function animatePlaceholder() {
            // Do not animate if the input is not empty
            if (inputSearch.value.trim() !== '') {
                return;
            }

            const newSpan = document.createElement('span');
            newSpan.className = 'placeholder-text enter';
            newSpan.textContent = messages[current];
            placeholderSearch.appendChild(newSpan);

            // Allow the browser to register the 'enter' state
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    newSpan.classList.add("enter-active");
                });
            });

            // Animate out the current (previous) span
            if (currentSpan) {
                const oldSpan = currentSpan;
                oldSpan.classList.remove('enter', 'enter-active');
                oldSpan.classList.add('exit');

                requestAnimationFrame(() => {
                    oldSpan.classList.add('exit-active');
                });

                setTimeout(() => {
                    if (placeholderSearch.contains(oldSpan)) {
                        placeholderSearch.removeChild(oldSpan);
                    }
                }, 500); // Match animation duration
            }

            currentSpan = newSpan;

            current = (current + 1) % messages.length;
        }

        animatePlaceholder();

        setInterval(animatePlaceholder, 3000);

        inputSearch.addEventListener('input', function () {
            placeholderSearch.style.display = this.value ? 'none' : 'block';
        });
    }

    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    iMask() {
        Helper.bindEventListener(document, 'input', '.date', (e) => {
            IMask(e.target, {
                mask: '00-00-0000'
            });
        });
    }

    popup () {
        const popup = document.getElementById('popup');

        if (popup === null) {
            return false;
        }

        const buttonToggle = popup.querySelector('[data-toggle="popup"]');

        buttonToggle.addEventListener('click', function () {
            popup.classList.toggle('popup--show');
        });

        let hasScrolled = false;

        window.addEventListener('scroll', () => {
            if (hasScrolled) {
                return;
            }

            if (window.scrollY > 20 && window.innerWidth >= 992) {
                popup.classList.add('popup--show');

                hasScrolled = true;
            }
        });
    }

    autoModals() {
        document.querySelectorAll('.modal-auto').forEach(modal => {
            bootstrap.Modal.getOrCreateInstance(modal).show();
        })
    }

    scrollIntoView() {
        document.addEventListener('click', function (e) {
            const anchor = e.target.closest('a[href]');

            if (!anchor) {
                return;
            }

            const href = anchor.getAttribute('href');

            // Match bare hash links (#id) or full URLs on the same page ending in #id
            let targetId = null;

            if (href.startsWith('#')) {
                // e.g. href="#signup"
                targetId = href.slice(1);
            }
            else {
                // e.g. href="https://example.com/page#signup"
                try {
                    const url = new URL(href, window.location.href);

                    if (url.hash && url.pathname === window.location.pathname && url.hostname === window.location.hostname) {
                        targetId = url.hash.slice(1);
                    }
                }
                catch (_) {} // Invalid URL, ignore
            }

            if (!targetId) {
                return;
            }

            const target = document.getElementById(targetId);

            if (target) {
                e.preventDefault();

                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    }

    responsiveEmbeds() {
        let wrap = function (toWrap, wrapper) {
            wrapper = wrapper || document.createElement('div');
            toWrap.parentNode.insertBefore(wrapper, toWrap);
            return wrapper.appendChild(toWrap);
        }

        // Responsive embeds
        document.querySelectorAll('iframe:not([class])').forEach(iframe => {
            let wrapper = document.createElement('div');

            wrapper.setAttribute('class', 'ratio ratio-16x9');

            wrap(iframe, wrapper);
        });
    }
}

window.addEventListener('load', () => new App());
